import { useGetUserQuery } from '@/api/piloteer';
import { Skeleton } from '@/ui/@components/primitives/skeleton';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const Greeting: FunctionComponent = () => {
  const { data: user, isLoading } = useGetUserQuery();
  const { t } = useTranslation();

  const getGreetingText = () => {
    const date = new Date();
    const hours = date.getHours();

    if (hours >= 4 && hours < 12) {
      return t('greeting.morning');
    } else if (hours >= 12 && hours < 18) {
      return t('greeting.afternoon');
    } else {
      return t('greeting.evening');
    }
  };

  return (
    <section className='py-12 mx-auto space-y-8 px-8 hidden md:block'>
      {isLoading ? (
        <Skeleton className='w-[300px]  h-6' />
      ) : (
        <h1 className='text-2xl font-light md:text-3xl'>
          {getGreetingText()},
          <span className='font-medium text-foreground'> {user?.name}</span>.
        </h1>
      )}
    </section>
  );
};
